"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    marko_component = {
    onCreate: function () {
        this.state = {
            confirmPwd: '',
            confirmError: null,
            submitting: false
        };
        GState.bind(this, ['tenant']);
        fhandler.bind(this);
    },
    onConfirm: function (e) {
        this.state.confirmPwd = e.target.value;
        this.state.confirmError = this.state.confirmPwd === this.state.form.new_password ? false : 'Passwords do not matche';
    },
    onSubmit: async function (e) {
        if (this.state.confirmError || this.state.submitting)
            return;
        const Form = this.state.form;
        if (!Form.new_password)
            return this.state.formError.new_password = true;
        Form.token = this.input.params.token;
        this.state.submitting = true;
        try {
            const {error, message, next} = await AuthRequest('/reset-pwd', 'PATCH', Form);
            this.state.submitting = false;
            fhandler.alert(message, error ? 'info' : 'success');
            if (error)
                return;
            !error && fhandler.reset();
            setTimeout(() => navigate('/' + (next || 'signin')), 3000);
        } catch (error) {
            this.state.submitting = false;
            fhandler.alert(error, 'warning');
        }
    }
},
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/smoothy~1.0/pages/Auth/ResetPwd.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    module_FormHandler = require("markojs-form"),
    FormHandler = module_FormHandler.default || module_FormHandler,
    TenantLogo_template = require("../../../components/TenantLogo/index.marko"),
    marko_loadTag = require("marko/dist/runtime/helpers/load-tag"),
    TenantLogo_tag = marko_loadTag(TenantLogo_template),
    Locale_template = require("../../../components/Locale/index.marko"),
    Locale_tag = marko_loadTag(Locale_template),
    Row_template = require("../../../components/Row/index.marko"),
    Row_tag = marko_loadTag(Row_template),
    FormAlert_template = require("../../../components/FormAlert/index.marko"),
    FormAlert_tag = marko_loadTag(FormAlert_template),
    Image_template = require("../../../components/Image/index.marko"),
    Image_tag = marko_loadTag(Image_template),
    marko_classValue = require("marko/dist/runtime/helpers/class-value"),
    Preloader_template = require("../../../components/Preloader/index.marko"),
    Preloader_tag = marko_loadTag(Preloader_template),
    Bx_template = require("../../../components/Bx/index.marko"),
    Bx_tag = marko_loadTag(Bx_template),
    route_link_template = require("marko-router5/src/components/route-link/index.marko"),
    route_link_tag = marko_loadTag(route_link_template),
    AuthLayout_template = require("../../components/AuthLayout/index.marko"),
    AuthLayout_tag = marko_loadTag(AuthLayout_template),
    marko_attrs0 = {
        "class": "card-header w-100 text-center pb-0"
      },
    marko_attrs1 = {
        "class": "card-body"
      },
    marko_createElement = require("marko/dist/runtime/vdom/helpers/v-element"),
    marko_const = require("marko/dist/runtime/vdom/helpers/const"),
    marko_const_nextId = marko_const("ffe5f9"),
    marko_node0 = marko_createElement("br", null, "9", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs2 = {
        "class": "mx-50"
      },
    marko_attrs3 = {
        "class": "form-group"
      },
    marko_attrs4 = {
        "class": "form-group"
      },
    marko_node1 = marko_createElement("br", null, "28", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs5 = {
        "class": "font-medium-1 mx-50 mt-4"
      },
    marko_attrs6 = {
        "class": "col-3"
      },
    marko_attrs7 = {
        "class": "col text-right"
      },
    marko_attrs8 = {
        "class": "font-medium-5"
      },
    marko_attrs9 = {
        "class": "mx-50"
      },
    marko_attrs10 = {
        "class": "text-center"
      },
    marko_attrs11 = {
        "class": "font-medium-2"
      },
    marko_attrs12 = {
        href: "/"
      },
    marko_node2 = marko_createElement("br", null, "20", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs13 = {
        "class": "mt-4 font-small"
      },
    marko_attrs14 = {
        "class": "mt-4 font-small"
      };

const fhandler = new FormHandler({ key: 'signin-form' });

function render(input, out, __component, component, state) {
  var data = input;

  const isNewAccount = !!input.params.ufn

  AuthLayout_tag({
      renderBody: function(out) {
        out.be("div", marko_attrs0, "1", component);

        Row_tag({
            class: "d-flex align-items-center",
            renderBody: function(out) {
              out.be("div", marko_attrs6, "3", component);

              TenantLogo_tag({
                  style: "width:40px"
                }, out, __component, "4");

              out.ee();

              out.be("div", marko_attrs7, "5", component);

              out.be("h4", marko_attrs8, "6", component);

              Locale_tag({
                  text: "Reset " + (isNewAccount ? "Account" : "Password")
                }, out, __component, "7");

              out.ee();

              out.ee();
            }
          }, out, __component, "2");

        out.ee();

        out.be("div", marko_attrs1, "8", component);

        out.n(marko_node0, component);

        FormAlert_tag({
            alert: state.alert,
            class: "mx-50"
          }, out, __component, "10");

        if (isNewAccount) {
          out.be("div", marko_attrs9, "11", component);

          out.be("div", marko_attrs10, "12", component);

          Image_tag({
              alt: "Image",
              src: "/images/illustration/forgotten-password.jpg",
              class: "img-fluid w-50"
            }, out, __component, "13");

          out.ee();

          out.be("h5", null, "14", component);

          Locale_tag({
              text: "Welcome back",
              class: "font-weight-400"
            }, out, __component, "15");

          out.t(", ");

          out.t(input.params.ufn, component);

          out.ee();

          out.be("p", marko_attrs11, "16", component);

          Locale_tag({
              renderBody: function(out) {
                out.t("Your new account is ready for you. Follow the next few steps to continue.");
              }
            }, out, __component, "17");

          out.t(" ");

          out.be("a", marko_attrs12, "18", component);

          Locale_tag({
              text: "Learn more"
            }, out, __component, "19");

          out.ee();

          out.ee();

          out.n(marko_node2, component);

          out.ee();
        }

        out.be("form", marko_attrs2, "@signin-form", component);

        out.be("div", marko_attrs3, "21", component);

        out.e("input", {
            "class": "form-control form-control-xl",
            type: "password",
            required: true,
            name: "new_password",
            value: state.form.new_password,
            placeholder: Locale("New Password")
          }, "22", component, 0, 0, {
            onchange: __component.d("change", "__onChange", false)
          });

        if (state.formError.new_password) {
          out.be("p", marko_attrs13, "23", component);

          Locale_tag({
              renderBody: function(out) {
                out.t("Enter you new password here.");
              }
            }, out, __component, "24");

          out.ee();
        }

        out.ee();

        out.be("div", marko_attrs4, "25", component);

        out.e("input", {
            type: "password",
            required: true,
            value: state.confirmPwd,
            "class": marko_classValue("form-control form-control-xl pl-4" + (state.confirmError !== null ? state.confirmError ? " is-invalid" : " is-valid" : "")),
            placeholder: Locale("Confirm Password")
          }, "26", component, 0, 0, {
            onchange: __component.d("change", "onConfirm", false)
          });

        if (state.confirmError) {
          out.e("p", marko_attrs14, "27", component, 1)
            .t((typeof state.confirmError) == "string" ? state.confirmError : "This field is required", component);
        }

        out.ee();

        out.n(marko_node1, component);

        out.be("button", {
            type: "submit",
            disabled: state.confirmError || state.submitting,
            "class": "btn btn-primary btn-xl text-left w-100"
          }, "29", component, null, 0, {
            onclick: __component.d("click", "onSubmit", false)
          });

        if (state.submitting) {
          Preloader_tag({
              class: "float-right font-medium-5",
              active: true
            }, out, __component, "30");
        } else {
          Bx_tag({
              type: "right-arrow-alt",
              class: "font-large-1 float-right white-text"
            }, out, __component, "31");
        }

        Locale_tag({
            text: "Continue"
          }, out, __component, "32");

        out.ee();

        out.ee();

        out.be("div", marko_attrs5, "33", component);

        Locale_tag({
            renderBody: function(out) {
              out.t("Remember password?");
            }
          }, out, __component, "34");

        out.t(" ");

        route_link_tag({
            href: "/signin",
            class: "text-secondary",
            renderBody: function(out) {
              Locale_tag({
                  text: "Sign-in",
                  class: "font-medium-1"
                }, out, __component, "36");
            }
          }, out, __component, "35");

        out.ee();

        out.ee();
      }
    }, out, __component, "0");
}

marko_template._ = marko_renderer(render, {
    e_: marko_componentType
  }, marko_component);

marko_template.Component = marko_defineComponent(marko_component, marko_template._);
